export default __webpack_public_path__ + "static/media/volkihar-armor.2a403d86.png";